export default function getHost() {
  return process?.env?.HOST || (typeof window !== 'undefined' ? window?.location?.host : '');
}
